export interface StyleOption {
  id: string
  name: string
  description: string
  previewImageUrl?: string
}

// Hardcoded to match backend IMAGE_STYLES — update both together
// Re-run: cd backend && npm run script:generate-style-previews to refresh previewImageUrl values
export const IMAGE_STYLE_OPTIONS: StyleOption[] = [
  {
    id: 'comic-70s',
    name: 'Comic Book 70s',
    description: 'Ben-Day dots, bold flat colors, thick ink outlines',
    previewImageUrl:
      'https://oicmbbcgdqbdhmtcwxdi.supabase.co/storage/v1/object/public/style-previews/comic-70s-5993e99d-939e-4f68-82db-dbea8e677cd8.webp',
  },
  {
    id: 'pencil-sketch',
    name: 'Pencil Sketch',
    description: 'Minimalist pencil lines on white, no color',
    previewImageUrl:
      'https://oicmbbcgdqbdhmtcwxdi.supabase.co/storage/v1/object/public/style-previews/pencil-sketch-e9f425e8-b185-4768-9969-50b40f238ee9.webp',
  },
  {
    id: 'bw-vector',
    name: 'B&W Vector',
    description: 'Clean corporate vector — pure black and white, flat geometric shapes, no color',
    previewImageUrl:
      'https://oicmbbcgdqbdhmtcwxdi.supabase.co/storage/v1/object/public/style-previews/bw-vector-1bcc2ec3-0271-4046-8f88-758bee50bdc4.webp',
  },
  {
    id: 'realistic-photo',
    name: 'Realistic',
    description: 'Photorealistic, cinematic studio lighting',
    previewImageUrl:
      'https://oicmbbcgdqbdhmtcwxdi.supabase.co/storage/v1/object/public/style-previews/realistic-photo-8bbd0c56-c5e7-471e-b88d-377963b68190.webp',
  },
]
